import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { CORE_ADMIN_ENTRIES } from "@/core/navigation/modulesRegistry";

const CARD_CLASSE =
  "group flex items-start gap-4 rounded-2xl border border-border bg-surface p-5 text-left transition-all hover:-translate-y-0.5 hover:border-primary hover:shadow-md";

/**
 * Aba "Núcleo" da barra fixa inferior (Sprint 3 — redesign Elos). Lista as
 * funções de gestão administrativa da igreja — o mesmo conteúdo que antes
 * vivia na seção "Gestão do Núcleo" da Início, agora com tela própria (a
 * Início virou só preview, sem atalhos de navegação — pedido do usuário).
 * Só admin da plataforma alcança esta rota (guard em AppRoutes) — por isso a
 * aba "Núcleo" só aparece na barra fixa para quem é admin (ver BottomTabBar).
 */
export function Nucleo() {
  const navigate = useNavigate();

  return (
    <main className="mx-auto w-full max-w-4xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
      <header className="mb-6">
        <h1 className="text-2xl font-black tracking-tight text-primary sm:text-3xl">Administração</h1>
        <p className="mt-1 text-sm text-muted">Gestão administrativa da igreja.</p>
      </header>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {CORE_ADMIN_ENTRIES.map((e) => {
          const Icone = e.icon;
          return (
            <button key={e.path} type="button" onClick={() => navigate(e.path)} className={CARD_CLASSE}>
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary">
                <Icone size={24} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-bold text-text">{e.label}</span>
                <span className="mt-1 block text-sm text-muted">{e.description}</span>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-primary">
                  Abrir
                  <ChevronRight size={16} className="transition-transform group-hover:translate-x-0.5" />
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </main>
  );
}
